import { DropdownButton, DropdownButtonType } from '@tableau/widgets';
import React from 'react';

import { Icons } from '~common/react/Icons';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { Messages } from '../../../codegen/Localize';
import { SharedViewsButtonStyle } from '../../styles/SharedViewsButtonStyle';
import { SharedViewsPopup, SharedViewsPopupId } from './SharedViewsPopup';

export const SharedViewsButtonTestId = 'shared-views-button';
export const SharedViewsButtonIconTestId = 'shared-views-button-icon';

export type SharedViewsButtonProps = {
  /** Used as the className of the ButtonWidget */
  className?: string;

  /** Used as the className of the container div */
  containerClassName?: string;

  urls: SpacesSiteUrls;

  viewId: string;
};

export class SharedViewsButton extends React.Component<SharedViewsButtonProps, {}> {

  // After content loads on the popup, rerender the button to allow
  // the popup to be re-positioned correctly (TFSID 1116706)
  private handleLoadComplete = (): void => {
    this.forceUpdate();
  }

  private getSharedViews = (): React.ReactNode => {
    return (
      <SharedViewsPopup
        onLoadComplete={this.handleLoadComplete}
        urls={this.props.urls}
        viewId={this.props.viewId}
      />
    );
  }

  private renderButton = (): React.ReactNode => {
    return (
      <Icons.sharedViews
        testId={SharedViewsButtonIconTestId}
        title={Messages.sharedWithMeCustomizedViewAltText()}
      />
    );
  }

  public render(): JSX.Element {
    return (
      <div
        className={this.props.containerClassName}
      >
        <DropdownButton
          aria-controls={SharedViewsPopupId}
          aria-haspopup={'listbox'}
          className={`${this.props.className} ${SharedViewsButtonStyle.DropdownButton}`}
          children={this.renderButton()}
          closeOnPopupBlur={true}
          focusOnClose={true}
          label={undefined}
          popupContent={this.getSharedViews()}
          testId={SharedViewsButtonTestId}
          type={DropdownButtonType.Icon}
        />
      </div>
    );
  }
}
